import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, useState, useRef, useEffect } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
  FormFeedback,
  Label,
} from "reactstrap";

import TablePrimaryComponent from "./Components/TablePrimaryComponent";
import TableSecondaryComponent from "./Components/TableSecondaryComponent";
import IndexBloc from "./Blocs/IndexBloc";

import moment from "moment";

const IndexView = (props) => {
  const indexBloc = new IndexBloc();

  const [activeTab, setactiveTab] = useState(
    sessionStorage.getItem("indexPppkActiveTab")
      ? sessionStorage.getItem("indexPppkActiveTab")
      : "1"
  );
  const [detailPeriod, setDetailPeriod] = useState(null);
  const activeRef = useRef();
  const secondaryRef = useRef();

  let queryParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    indexBloc.detailPeriodChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            setDetailPeriod(response);
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    indexBloc.fetchDetailPeriod({ uuid: queryParams.get("uuid") });

    return () => {
      console.log("unmount");
      indexBloc.detailPeriodChannel?.unsubscribe();
    };
  }, []);

  const reloadInactiveRef = () => activeRef.current.setTokenAPI();
  const reloadSecondaryRef = () => secondaryRef.current.setTokenAPI();

  function toggle(tab) {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  }

  return (
    <Fragment>
      <Container fluid>
        <Row>
          <Col xs="12">
            <Card className="">
              <CardBody>
                <div className="float-end">
                  {/* {
                                    (accessRole('create')) ?
                                        <Link to="?create">
                                            <Button color="primary">Tambah Data</Button>
                                        </Link>
                                    : null
                                } */}
                </div>
                <CardTitle>List PPPK</CardTitle>
                <CardSubtitle className="mb-3">
                  Periode{" "}
                  {detailPeriod != null
                    ? moment()
                        .month(detailPeriod.cp3k_period_month - 1)
                        .locale("id-id")
                        .format("MMMM")
                    : "-"}{" "}
                  {detailPeriod != null ? detailPeriod.cp3k_period_year : "-"}
                </CardSubtitle>
                <hr />
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === "1",
                      })}
                      onClick={() => {
                        toggle("1");
                        sessionStorage.setItem("indexPppkActiveTab", "1");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="fas fa-home"></i>
                      </span>
                      <span className="d-none d-sm-block">Menunggu Proses</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === "2",
                      })}
                      onClick={() => {
                        toggle("2");
                        sessionStorage.setItem("indexPppkActiveTab", "2");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-envelope"></i>
                      </span>
                      <span className="d-none d-sm-block">Data Diproses</span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} className="p-3 text-muted">
                  <TabPane tabId="1">
                    <TablePrimaryComponent
                      ref={activeRef}
                      handleProcessSuccess={reloadSecondaryRef}
                    />
                  </TabPane>
                  <TabPane tabId="2">
                    <TableSecondaryComponent ref={secondaryRef} />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default IndexView;
